<template>
<div class="chapter">
<div class="inner_page">
<p class="title" id="tp">Dead Aim</p>
<p class="subtitle">A Chris Klick Mystery</p>
<p class="author">Ridley Pearson</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?61d3ed01